import React from "react";
import appConstants from "../../../../../appConstants";
import { format } from "date-fns";
import CustomDateRange from "../CustomDateRange";
import { CustomDateRangeDayRenderer } from "../Days";
import {
  checkPlanAlreadyInitialized,
  isHoliday,
  getHolidayName,
} from "../utils";
import { APP_DATE_FORMAT } from "../../constants";

const CustomDateRangeComponent = ({
  terminalDate,
  holidays,
  initializedDates,
  dateRange,
  onDateRangeChange,
}) => {
  const customDayContent = (day) => {
    const holidayName = getHolidayName(day, holidays);
    return (
      <CustomDateRangeDayRenderer
        day={day}
        formattedDateToRender={format(day, "d")}
        endDate={dateRange[0]?.endDate}
        startDate={dateRange[0]?.startDate}
        isInitializedPlanDate={checkPlanAlreadyInitialized(
          day,
          initializedDates
        )}
        isHoliday={isHoliday(day, holidays)}
        isDisabled={
          format(day, APP_DATE_FORMAT) < format(terminalDate, APP_DATE_FORMAT)
        }
        holidayName={holidayName}
      />
    );
  };

  return (
    <CustomDateRange
      startDate={dateRange[0].startDate}
      endDate={dateRange[0].endDate}
      dateRange={dateRange}
      minDate={terminalDate}
      onChange={onDateRangeChange}
      dateFormat={appConstants.DATETYPES.MONTHDATEYEAR.format}
      dayContentRenderer={customDayContent}
      startDatePlaceholder="Start Date"
      endDatePlaceholder="End Date"
      transformOriginValue="center"
    />
  );
};

export default CustomDateRangeComponent;
